export default __webpack_public_path__ + "static/7-44e6567359a24bd877c005555e6284f5.jpg";